import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { globalVariables } from 'src/app/core/constants/globalVariables';

@Component({
  selector: 'app-employee-list-one',
  templateUrl: './../../../templates/forms/modals/employee-list-one.component.html'
})
export class EmployeeListOneComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "EmployeeListOneGridID"

  employeeList: any[] = [];
  constructor(private dataService: DataLoadService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.dtlName, field: 'DTL_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.value, field: 'LOOKUPDTL_NO', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.load('FG_SA_COMM_CONFIGARATION', JSON.parse(JSON.stringify({ P_LOOKUP_NO : '1007' }))).subscribe(results => {
      this.employeeList = results.body;
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }
}
